var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow1TracedLeftPAgination(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8044 0.0719422C9.95895 0.131286 10.0761 0.225048 10.4062 0.553512C10.9124 1.05723 10.9813 1.17754 10.9826 1.55905C10.9833 1.76405 10.9654 1.87844 10.9168 1.98093C10.8715 2.0763 9.74573 3.2276 7.41891 5.55818L3.98776 8.99477L7.4227 12.4312C10.0947 15.1043 10.8734 15.9028 10.9286 16.0258C10.9761 16.1316 10.9997 16.2598 11 16.4126C11.0007 16.773 10.8979 16.9511 10.4099 17.4352C10.0666 17.7758 9.96577 17.8552 9.79568 17.9186C9.53929 18.0143 9.33637 18.0148 9.07765 17.9202C8.88278 17.8489 8.69976 17.6715 4.75368 13.7278C0.195172 9.17202 0.454941 9.45806 0.454941 8.99459C0.454941 8.53113 0.195172 8.81716 4.75368 4.26123C8.70173 0.315399 8.88267 0.139969 9.07765 0.0688484C9.3319 -0.0239288 9.55715 -0.0229796 9.8044 0.0719422Z",
    fill: "#FF9900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow1TracedLeftPAgination);
export default __webpack_public_path__ + "static/media/right-arrow 1 (Traced)Left_PAgination.26027a84e29aa7644d0e32c0f3ab0617.svg";
export { ForwardRef as ReactComponent };